export var PopoverTriggerAction;
(function (PopoverTriggerAction) {
    PopoverTriggerAction["hover"] = "hover";
    PopoverTriggerAction["click"] = "click";
})(PopoverTriggerAction || (PopoverTriggerAction = {}));
//# sourceMappingURL=types.js.map